import {
  getAffiliates, getAffiliate, postAffiliate, putAffiliate, exportAffiliates, importAffiliates,
} from '../../../Api/services/backoffice';

export const key = 'affiliate';

const entityName = {
  singular: 'Filial',
  plural: 'Filiais',
};

const queries = {
  list: { key, fn: getAffiliates },
  detail: { key, fn: getAffiliate },
};

const mutations = {
  create: postAffiliate,
  update: putAffiliate,
};

const fields = {
  table: [
    { key: 'code', label: 'Código' },
    { key: 'name', label: 'Nome' },
    { key: 'description', label: 'Descrição' },
    { key: 'minMissing', label: 'Min. m³ faltante' },
    { key: 'complementaryAdditional', label: 'Add complementar' },
  ],
};

export const listConfig = {
  title: entityName.plural,
  tableFields: fields.table,
  searchFields: fields.search,
  queryConfig: queries.list,
  showBatchButton: true,
};

export const createConfig = {
  entityName: entityName.singular,
  mutationFn: mutations.create,
};

export const updateConfig = {
  entityName: entityName.singular,
  mutationFn: mutations.update,
  queryConfig: queries.detail,
};

export const batchConfig = {
  entityName: entityName.plural,
  exportFn: exportAffiliates,
  importFn: importAffiliates,
};
